export default "__VITE_ASSET__CjE9S7pY__"